import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import i18nMessages from './__i18n__';
import classNames from 'classnames';
import { FaIcon } from '../../common/fa_icons';

const ON_SALE_VALUE = '1';

export const ProductListSaleSelect = ({ handleSaleToggle, on_sale, intl }) => {
  const messages = i18nMessages();

  return (
    <div className="sale-select">
      <span className="sale">
        {intl.formatMessage(messages.sale)}
      </span>
      <div name="filterBySale"
        tabIndex="0" aria-label="on sale"
        data-name="sale"
        className={classNames('sale-checkbox', {
          'checked': on_sale === ON_SALE_VALUE
        })}
        onClick={handleSaleToggle}
        onKeyPress={handleSaleToggle}
      >
        {on_sale === ON_SALE_VALUE && <FaIcon iconName="check" />}
      </div>
    </div>
  );
};

ProductListSaleSelect.propTypes = {
  handleSaleToggle: PropTypes.func.isRequired,
  on_sale: PropTypes.oneOf([
    ON_SALE_VALUE,
    null
  ]),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  })
};

export default injectIntl(ProductListSaleSelect);
